<template>
    <div>
        <div id="viewerContainer" style="width:100%;height:150vh"></div>
    </div>
</template>
<script>
import axios from "axios";

export default {
    props: ['section'],
    data() {
        return {
            sheetId:null,
            sessionId:null,
            workbookControl:null,
            prizmSheetBaseURL:null,
            overlayText:''
        }
    },
    created() {
    },
    mounted() {
        $(function() {
            $('#viewerContainer').pccViewer({
                documentID:     'N2YVgq3OEtmB2RzMlotPTr6qWODngBNE6f1vBwWC3ug_',
                imageHandlerUrl:  'http://localhost/pas/',
                viewerAssetsPath: 'viewer-assets',
                resourcePath:     'viewer-assets/img',
                language: viewerCustomizations.languages['en-US'],
                template: viewerCustomizations.template,
                icons:    viewerCustomizations.icons,
                annotationsMode: "LayeredAnnotations"
            });
        });
    },
    methods: {

    },
}
</script>
<style lang="scss" escoped>
.proposal-overlay-content-save{
    position: fixed;
    display: none;
    width: 100%;
    height: 100%;
    top:18px;
    left: 0;
    right: 0;
    bottom: 0;
    //background-color: rgba(0,0,0,0.5);
    z-index: 999;
    cursor: pointer;
    background: #ffffffd9;
}
.proposal-overlay-content-save img{
    position: absolute;
    right: 42.5%;
    top: 18%;
}
.proposal-overlay-content-save h1{
    position: absolute;
    color: #01b1af;
    top: 50%;
    right: 42.5%;
    font-weight: 200;
}
</style>
